import apiConfig from "constants/apiConfig";
import { DEFAULT_CREATOR_COLLECTION_ID, DEFAULT_POST_COLLECTION_ID } from "constants/global";
import axiosClient from "utils/axiosClient";

export const fetchCollections = async (agencyId: string, filters: any = {}) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLECTIONS.url.replace('<agencyId>', agencyId), { params: filters });
    return response.data;
}

export const fetchPostCollection = async (agencyId: string, filters: any = {}, collection?: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_POST_COLLECTION.url.replace('<agencyId>', agencyId), { params: { ...filters, ...((collection && collection !== DEFAULT_POST_COLLECTION_ID) ? { collection } : {}) } });
    return response.data;
}

export const fetchCreatorsCollection = async (agencyId: string, filters: any = {}, collection?: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CREATORS_COLLECTION.url.replace('<agencyId>', agencyId), { params: { ...filters, ...((collection && collection !== DEFAULT_CREATOR_COLLECTION_ID) ? { collection } : {}) } });
    return response.data;
}

export const createCollection = async (agencyId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.CREATE_COLLECTION.url.replace('<agencyId>', agencyId), payload);
    return response.data;
}

export const addToCollection = async (agencyId: string, uuid: string, type: 'post' | 'account', collection?: string) => {
    const response = await axiosClient.post(apiConfig.ADD_TO_COLLECTION.url.replace('<agencyId>', agencyId), { uuid, type, collection });
    return response.data;
}

export const removeFromCollectionAPI = async (agencyId: string, uuid: string, type: 'post' | 'account', collection?: string) => {
    const response = await axiosClient.post(apiConfig.REMOVE_FROM_COLLECTION.url.replace('<agencyId>', agencyId), { uuid, type, collection });
    return response.data;
}